{
  "data": [
    {
      "name": "555 Halal Thai",
      "location": "1.419287, 103.718752",
      "vicinity": " 10 Neo Tiew Lane 2, #01-09, Singapore    S(718813)",
      "information": "&lt;p&gt;We aim to serve the perfect gathering spot for friends and family to enjoy authentic Thai dishes and uniquely local street food.&lt;/p&gt;\r\n",
      "terms": null,
      "number": null,
      "site": null,
      "photos": [""],
      "videos": null,
      "url": "node/10326"
    },
    {
      "name": "89.7 Supper Club Pte Ltd",
      "location": "1.318685, 103.89151",
      "vicinity": " 1016 Geylang East Ave 3, #01-165, Singapore    S(389731)",
      "information": null,
      "terms": null,
      "number": "6841 6897",
      "site": null,
      "photos": null,
      "videos": null,
      "url": "node/10326"
    },
    {
      "name": "A. Wahab Frozen Food & Halal Chicken",
      "location": "1.33197, 103.924551",
      "vicinity": " 538 Bedok North Street 3, #01-11, 01-24, Block 538, Bedok North, Market and Food Centre, Singapore    S(460538)",
      "information": null,
      "terms": null,
      "number": null,
      "site": null,
      "photos": null,
      "videos": null,
      "url": "node/10326"
    },
    {
      "name": "Afghanistan Family Restaurant",
      "location": "1.353589, 103.954026",
      "vicinity": " 201E Tampines Street 23, Singapore  Tampines  S(527201)",
      "information": null,
      "terms": null,
      "number": "9829 4907",
      "site": null,
      "photos": null,
      "videos": null,
      "url": "node/10326"
    },
    {
      "name": "AK Salmal Eating House",
      "location": "1.348569, 103.8495696",
      "vicinity": " 509 Bishan Street 11, Singapore  Bishan  S(570509)",
      "information": "&lt;p&gt;At AK SALMAL EATING HOUSE we offer meals of excellent quality and invite you to try our delicious food.&lt;/p&gt;\r\n\r\n&lt;p&gt;The key to our success is simple: providing quality consistent food that taste great every single time. We pride ourselves on serving our customers delicious genuine dishes like: Indian, Thai, North Indian&lt;/p&gt;\r\n\r\n&lt;p&gt;Eat delicious food. Grab a drink. But most of all, relax! We thank you from the bottom of our hearts for your continued support.&lt;/p&gt;\r\n",
      "terms": null,
      "number": "8119 2492",
      "site": null,
      "photos": null,
      "videos": null,
      "url": "node/10326"
    },
    {
      "name": "Al - Baik Halal Beef",
      "location": "1.389871, 103.98815",
      "vicinity": " 2 Changi Village Rd, #01-118, 119 Village Hawker Centre, Singapore    S(500002)",
      "information": null,
      "terms": null,
      "number": null,
      "site": null,
      "photos": null,
      "videos": null,
      "url": "node/10326"
    },
    {
      "name": "Al Afrose Restaurant",
      "location": "1.2952169, 103.8295609",
      "vicinity": " 421 River Valley Rd, Singapore  River Valley  S(248320)",
      "information": null,
      "terms": null,
      "number": "6737 5715",
      "site": null,
      "photos": null,
      "videos": null,
      "url": "node/10326"
    },
    {
      "name": "AL HABIB INDIAN MUSLIM FOOD",
      "location": "1.4523966, 103.8175192",
      "vicinity": " Sembawang Dr, #01-01, SINGAPORE 751406 BLK 406A, Singapore  Sembawang  S(751406)",
      "information": null,
      "terms": null,
      "number": "9170 4654",
      "site": null,
      "photos": null,
      "videos": null,
      "url": "node/10326"
    },
    {
      "name": "Al Hadheerah Restaurant (HDB Hub)",
      "location": "1.332286, 103.848371",
      "vicinity": " 480 Lor 6 Toa Payoh, #B1- 01, Singapore  Toa Payoh  S(310480)",
      "information": null,
      "terms": null,
      "number": "8552 2899",
      "site": null,
      "photos": null,
      "videos": null,
      "url": "node/10326"
    },
    {
      "name": "Al Mahboob Rojak",
      "location": "1.3522251, 103.9418274",
      "vicinity": " 300 Tampines Ave 5, #01-02, Singapore  Tampines  S(529653)",
      "information": null,
      "terms": null,
      "number": "6788 2257",
      "site": null,
      "photos": null,
      "videos": null,
      "url": "node/10326"
    },
    {
      "name": "Al Moreish Restaurant",
      "location": "1.286258, 103.821659",
      "vicinity": " 95D Henderson Rd, #01-01, Singapore    S(154095)",
      "information": "&lt;p&gt;Moreish Prata @ Henderson Road is a Singapore Indian Muslim restaurant. The comfy ambience of the restaurant is a perfect place for all to meet to eat!&lt;/p&gt;\r\n",
      "terms": null,
      "number": "6253 4323",
      "site": null,
      "photos": null,
      "videos": null,
      "url": "node/10326"
    },
    {
      "name": "Al-Azhar Eating Restaurant",
      "location": "1.352019, 103.953904",
      "vicinity": " 201D Tampines Street 21, #01-1155, Singapore  Tampines  S(524201)",
      "information": "&lt;p&gt;Al-Azhar reinvents the dining experience with a fresh approach and energy,focusing on the quality of ingredients and its execution while retaining its familiarity and authenticity. Through the innovative use of ingredients and its execution, each visit brings it new flavours and a different type of experience. Most dishes are designed for sharing, so guest can try a variety of offering.&lt;/p&gt;\r\n\r\n&lt;p&gt;Al-Azhar restaurants catered to customers in meeting their daily meal to fulfil your needs regardless of breakfast, lunch, supper or dinner. We ensure that we are always open for 24hours. We provide varieties of food from Thai Muslim food, local dishes, indian cuisine, seafood, western grill varieties, Mediterranean dishes and if you are fast enough to grab our Malay Nasi padang dishes that will be cleared after Lunch hour.&lt;/p&gt;\r\n\r\n&lt;p&gt;At Al-Azhar, we take our drinks seriously. The produce are carefully sourced and procured fresh daily. The experience nurtures innovation and creativity. From fresh fruit juice to combinations of drinks, you can have it with mixed flavour or fruits. Even our desserts is full of creativity with a wide range of selections.&lt;/p&gt;\r\n",
      "terms": null,
      "number": "6785 1265",
      "site": null,
      "photos": null,
      "videos": null,
      "url": "node/10326"
    },
    {
      "name": "Al-Fazl Restaurant",
      "location": "1.33307, 103.915497",
      "vicinity": " 631 Bedok Reservoir Rd, Singapore  Bedok  S(470631)",
      "information": null,
      "terms": null,
      "number": "6575 7030",
      "site": null,
      "photos": null,
      "videos": null,
      "url": "node/10326"
    },
    {
      "name": "Anak Bapak Halal Muslim Restaurant",
      "location": "1.3202535, 103.9039335",
      "vicinity": " 4A Eunos Cres, #01-16, Singapore (Eunos Crescent Market and Food Centre)   S(402004)",
      "information": null,
      "terms": null,
      "number": null,
      "site": null,
      "photos": null,
      "videos": null,
      "url": "node/10326"
    },
    {
      "name": "ANDES by ASTONS @ Downtown East",
      "location": "1.3772159, 103.9550254",
      "vicinity": " 1 Pasir Ris Cl, #02-325, Singapore  Pasir Ris  S(519599)",
      "information": "&lt;p&gt;&lt;strong&gt;ANDES BY ASTONS&lt;/strong&gt;&amp;nbsp;is the much sought after halal version of&amp;nbsp;&lt;strong&gt;ASTONS Specialities,&lt;/strong&gt;&amp;nbsp;branded in the traditional cowboy themed settings at best value and quality concept catered for everyone.&lt;/p&gt;\r\n\r\n&lt;p&gt;Bridging the gap for good halal western cuisine, ANDES By ASTONS is halal certified and accredited by MUIS.&lt;/p&gt;\r\n\r\n&lt;p&gt;We as a local food chain well-known for its value-for-money dining concept where discerning diners applaud our fantastic food and prices.&lt;/p&gt;\r\n\r\n&lt;p&gt;With the philosophy that it is possible to offer great food at great prices,&amp;nbsp;&lt;strong&gt;ANDES&amp;nbsp;&lt;/strong&gt;insists on quality ingredients and generous portions.&lt;br /&gt;\r\n&lt;br /&gt;\r\nOur main menu includes a wide selection of steak cuts, chicken and seafood with most of the main course including 2 side dishes where diners can select from our varieties of choices to suit their desires.&lt;br /&gt;\r\n&lt;br /&gt;\r\nAt&amp;nbsp;&lt;strong&gt;ANDES&lt;/strong&gt;, we definitely have something to satisfy all.&lt;/p&gt;\r\n",
      "terms": null,
      "number": "6386 5270",
      "site": null,
      "photos": null,
      "videos": null,
      "url": "node/10326"
    },
    {
      "name": "Annie's Halal Cuisine",
      "location": "1.323273, 103.854871",
      "vicinity": " 90 Whampoa Dr, #01-73, Singapore    S(320090)",
      "information": "&lt;p&gt;Annie's Halal Cuisine aims to share the pleasure of her food with everyone.&lt;br /&gt;\r\n&lt;br /&gt;\r\nPassionately prepared by Mummy Annie and it is 100% Muslim owned.&lt;/p&gt;\r\n",
      "terms": null,
      "number": "8862 2334",
      "site": null,
      "photos": null,
      "videos": null,
      "url": "node/10326"
    },
    {
      "name": "As-Safeera Restaurant",
      "location": "1.3533518, 103.8677014",
      "vicinity": " 301 Serangoon Ave 2, Block 301, Singapore  Serangoon  S(550301)",
      "information": "&lt;p&gt;Specialist in India, Malay and Thai Seafood.&lt;br /&gt;\r\nMouth-Watering tasty food not to be missed!&lt;br /&gt;\r\nWide variety of prata and Tasty biryani!&lt;/p&gt;\r\n",
      "terms": null,
      "number": "8351 5247",
      "site": null,
      "photos": null,
      "videos": null,
      "url": "node/10326"
    },
    {
      "name": "Asam Tree Cafe, Bakery & Restaurant",
      "location": "1.3716144, 103.8470382",
      "vicinity": " Blk 712 #01, Ang Mo Kio Ave 6, 4056 Ang Mo Kio  S(560712)",
      "information": "&lt;p&gt;Serving&amp;nbsp;Nasi Padang, Malay Food, Nasi Lemak, Chicken Rice, Chicken Noodle, Ayam Penyet, Lontong, Mee Rebus, Mee Siam, Mee Soto, Rojak, Roti Bakar, and Beverage.&lt;/p&gt;\r\n",
      "terms": null,
      "number": " 9489 1336",
      "site": null,
      "photos": [""],
      "videos": null,
      "url": "node/10326"
    },
    {
      "name": "Asli Village",
      "location": "1.3769815, 103.9544216",
      "vicinity": " #02-333 Market Square E! Avenue, 1 Pasir Ris Cl,  Pasir Ris  S(519599)",
      "information": null,
      "terms": null,
      "number": "6288 0212",
      "site": null,
      "photos": null,
      "videos": null,
      "url": "node/10326"
    },
    {
      "name": "Atrium Restaurant",
      "location": "1.2888829, 103.834153",
      "vicinity": " 317 Outram Rd, Singapore  Outram  S(169075)",
      "information": null,
      "terms": null,
      "number": null,
      "site": null,
      "photos": null,
      "videos": null,
      "url": "node/10326"
    },
    {
      "name": "Ayam Penyet President",
      "location": "1.352505, 103.9439658",
      "vicinity": " 2 Tampines Central 5, #B1-20 Century Square, Singapore  Tampines  S(529509)",
      "information": "&lt;p&gt;Ayam Penyet President is&amp;nbsp;a chain of value-for-money casual dining restaurants serving authentic Indonesian cuisine.&lt;/p&gt;\r\n",
      "terms": null,
      "number": "6260 2469",
      "site": null,
      "photos": [""],
      "videos": null,
      "url": "node/10326"
    },
    {
      "name": "Ayza’s Restaurant",
      "location": "1.348719, 103.718787",
      "vicinity": " 508 Jurong West Street 52, Singapore  Jurong West  S(640508)",
      "information": "&lt;p&gt;2002 was the year we started off working as a family business by selling drinks at Upper Bukit Timah Road at Beauty World Center.&lt;br /&gt;\r\n&lt;br /&gt;\r\nWe succeeded in expanding our business and we started our one and only Ayza's Restaurant. It is famous for serving varieties of food such as Nasi Pandang,Indian Muslim food/North Indian food, Thai seafood, Ayam Penyet and Western food.&lt;br /&gt;\r\n&lt;br /&gt;\r\nAyza’s restaurant was firstly opened in 2009, located at Block 492 Jurong West Street 42.&lt;br /&gt;\r\n&lt;br /&gt;\r\nLater on, after a few years, we then shifted to 431 Jalan Lenkok Sembawang. 2012 was when we finally moved to Block 508 Jurong West Street 52, where we are still serving with great pleasure.&lt;/p&gt;\r\n",
      "terms": null,
      "number": "6756 4963",
      "site": null,
      "photos": [""],
      "videos": null,
      "url": "node/10326"
    },
    {
      "name": "BARAKKAT EXCELLENT BIRYANI MUSLIM FOOD HALAL",
      "location": "1.2802121, 103.8447371",
      "vicinity": " 1 Kadayanallur St, Singapore    S(69184)",
      "information": null,
      "terms": null,
      "number": null,
      "site": null,
      "photos": null,
      "videos": null,
      "url": "node/10326"
    },
    {
      "name": "Buey Tahan See-Food Choa Chu Kang",
      "location": "1.374021, 103.74625",
      "vicinity": " 810 Choa Chu Kang Ave 7, #01-11, Singapore  Choa Chu Kang  S(680810)",
      "information": "&lt;p&gt;Buey Tahan Seefood offers halal seafood with more than 200 halal zichar dishes.&lt;/p&gt;\r\n",
      "terms": null,
      "number": "8223 7943",
      "site": null,
      "photos": [""],
      "videos": null,
      "url": "node/10326"
    },
    {
      "name": "Cahaya Restaurant",
      "location": "1.3074987, 103.8337924",
      "vicinity": " 14, Scotts Rd, #05-91/92, Far East Plaza,  Orchard  S(228213)",
      "information": "&lt;p&gt;Cahaya restaurant is a halal certified restaurant. it have been started since 1987 and has been offering local food at very economical price in the heart of town area ever since.&lt;/p&gt;\r\n",
      "terms": null,
      "number": "6734 8434",
      "site": null,
      "photos": [""],
      "videos": null,
      "url": "node/10326"
    },
    {
      "name": "Cajun on Wheels, Plaza Singapura",
      "location": "1.3007914, 103.8449976",
      "vicinity": " 68 Orchard Rd, Plaza Singapura, #03-92,  Orchard  S(238839)",
      "information": "&lt;h2 data-css=&quot;tve-u-16eb629994d&quot;&gt;ABSOLUTELY NO SERVICE CHARGE FOR DINE-IN!&lt;/h2&gt;\r\n\r\n&lt;p data-css=&quot;tve-u-16eb62a9891&quot;&gt;Our restaurant is a self-service restaurant which allows us to pass all the delicious savings to you!&lt;br /&gt;\r\nJust order up at our counter and we'll send to the food to your table as soon as it's ready.&lt;/p&gt;\r\n",
      "terms": null,
      "number": "6341 9665",
      "site": null,
      "photos": [""],
      "videos": null,
      "url": "node/10326"
    },
    {
      "name": "Chumpo2",
      "location": "1.3666768, 103.9641877",
      "vicinity": " 258 Pasir Ris Street 21, Singapore    S(510258)",
      "information": null,
      "terms": null,
      "number": null,
      "site": null,
      "photos": null,
      "videos": null,
      "url": "node/10326"
    },
    {
      "name": "Citrus By The Pool",
      "location": "1.4345226, 103.7795476",
      "vicinity": " 3 Woodlands Street 13 Woodlands Swimming Complex,  Woodlands  S(738600)",
      "information": "&lt;h2&gt;Nothing Brings People Together Likes Good Food&lt;/h2&gt;\r\n\r\n&lt;h2&gt;A Place To Bond And Celebrate&lt;/h2&gt;\r\n\r\n&lt;p&gt;Our vision is to create meeting spaces for people to bond and create happy memories. We want to bring smiles and laughter, joy and cheer, to every individual who dines with us.&amp;nbsp;​&lt;br /&gt;\r\n&lt;br /&gt;\r\nStarted in 2013,&amp;nbsp;&lt;a href=&quot;https://www.citrusbythepool.com/citrus-by-the-pool-woodlands&quot; target=&quot;_blank&quot;&gt;Citrus By The Pool&lt;/a&gt;&amp;nbsp;is a Halal-certified café restaurant, nestled at Woodlands Swimming Complex, that serves Western and Asian Fusion cuisine.&lt;br /&gt;\r\n&lt;br /&gt;\r\nSeeing a lack of Halal-certified cafés in the North, the owner Chris decided to bring the café experience to the residential estates, offering accessibility, relaxing ambience and good food.&lt;/p&gt;\r\n\r\n&lt;p&gt;​&lt;/p&gt;\r\n",
      "terms": null,
      "number": "6366 6581",
      "site": null,
      "photos": [""],
      "videos": null,
      "url": "node/10326"
    },
    {
      "name": "Communal Dining by Dad's Corner",
      "location": "1.345967, 103.871562",
      "vicinity": " 534 Upper Serangoon Rd, Singapore  Serangoon  S(534549)",
      "information": "&lt;p&gt;Dad’s Corner was founded in 2014 and is 100% Muslim Owned by Chef Faddil. Chef Faddil graduated with Diploma in Culinary Arts, At-Sunrice GlobalChef Academy.&lt;/p&gt;\r\n\r\n&lt;p&gt;In 2014, Dad’s Corner introduced Halal Western Fusion Asian cuisines. It was well received by the Muslim community due to limited supply at that time.&lt;/p&gt;\r\n\r\n&lt;p&gt;In 2016, Dad’s Corner introduced SHELLOUT in their menu which is famous till today for its fresh quality and homemade fusion sauces. Dad’s Corner Shellout has since remain as our specialty.&lt;/p&gt;\r\n\r\n&lt;p&gt;In 2017, Dad’s Corner started their Wedding catering services, offering attractive wedding packages at our restaurant venue.&lt;/p&gt;\r\n\r\n&lt;p&gt;In 2018, the 1ST HALAL TREETOP PRIVATE DINING LIKE NO OTHER was founded by Dad’s Corner. It was featured as Singapore’s Top 10 Halal romantic dining in Tripzilla.com.&lt;/p&gt;\r\n\r\n&lt;p&gt;In 2020 Dad’s Corner has expanded and managing few businesses under its umbrella, and Insya Allah more to come.&lt;br /&gt;\r\n– 1st Halal Treetop Dining&lt;br /&gt;\r\n– Restaurant Service&lt;br /&gt;\r\n– Wedding Catering and Deco Services&lt;br /&gt;\r\n– Grillout at 534 Upper Serangoon Road&lt;br /&gt;\r\n– Nasi Padang stall at Ark@Gambas&lt;/p&gt;\r\n",
      "terms": null,
      "number": "8850 1617",
      "site": null,
      "photos": [""],
      "videos": null,
      "url": "node/10326"
    },
    {
      "name": "Crave - White Sands",
      "location": "1.3723654, 103.9496751",
      "vicinity": " 1 Pasir Ris Central Street 3, #B1-K16, Singapore  Pasir Ris  S(518457)",
      "information": "&lt;p&gt;t Crave, traditional cooking methods &amp;nbsp;are used&amp;nbsp;on the freshest ingredients to create the ultimate Nasi Lemak (Fragrant Coconut Rice). Using the secret recipe of Selara Rasa – The Original Adam Road Nasi Lemak.&amp;nbsp;Emphasis is placed&amp;nbsp;on every detail that reaches out to their customers, creating the unique experience on-the-go. Making you Crave for more!&lt;/p&gt;\r\n",
      "terms": null,
      "number": "6385 5602",
      "site": null,
      "photos": [""],
      "videos": null,
      "url": "node/10326"
    },
    {
      "name": "Crave Nasi Lemak (E!Hub@Downtown East)",
      "location": "1.3764492, 103.9558526",
      "vicinity": " 1 Pasir Ris Close #01-K105 Ehub@Downtown East, Singapore  Pasir Ris  S(519599)",
      "information": "&lt;p&gt;CRAVE is a food establishment that houses the famous&amp;nbsp;Selera Rasa’s nasi lemak&amp;nbsp;and famous teh tarik from Rafee’s Corner. Here is&amp;nbsp;where Singaporeans and tourists&amp;nbsp;can enjoy a comforting combination that pays&amp;nbsp;tribute to the nation’s rich food and&amp;nbsp;beverage heritage.&amp;nbsp;&lt;/p&gt;\r\n",
      "terms": null,
      "number": null,
      "site": null,
      "photos": [""],
      "videos": null,
      "url": "node/10326"
    },
    {
      "name": "Crave Nasi Lemak (Jurong Point)",
      "location": "1.340022, 103.706748",
      "vicinity": " 1 Jurong West Central 2, #B1, 03 Jurong Point, Singapore  Jurong West  S(648886)",
      "information": "&lt;p&gt;Savour the nation's favourite by indulging at Crave, enjoy some award-winning Adam Road Nasi Lemak by Selera Rasa, topped off with crunchy flavourful ikan bilis, nuts and the tantalising iconic sambal! What's more? Top it off with the famous teh tarik from Rafee's Corner for a fulfilling meal!&amp;nbsp;&lt;/p&gt;\r\n",
      "terms": null,
      "number": "6252 3110",
      "site": null,
      "photos": [""],
      "videos": null,
      "url": "node/10326"
    },
    {
      "name": "Dajie - Halal Chicken Rice & Niang Dou Fu",
      "location": "1.358896, 103.75141",
      "vicinity": " 372 Bukit Batok Street 31, #01-374, Singapore  Bukit Batok  S(650372)",
      "information": null,
      "terms": null,
      "number": "6896 4569",
      "site": null,
      "photos": [""],
      "videos": null,
      "url": "node/10326"
    },
    {
      "name": "Dajie - Halal Mala Hotpot, Chicken Rice & Niang Dou Fu",
      "location": "1.314451, 103.770282",
      "vicinity": " 354 Clementi Ave 2, #01-253, Singapore  Clementi  S(120354)",
      "information": null,
      "terms": null,
      "number": "6774 2030",
      "site": null,
      "photos": [""],
      "videos": null,
      "url": "node/10326"
    },
    {
      "name": "De' Pearl Cafe",
      "location": "1.2866057, 103.849033",
      "vicinity": " 73 Circular Rd, Singapore    S(49427)",
      "information": null,
      "terms": null,
      "number": "6611 1206",
      "site": null,
      "photos": null,
      "videos": null,
      "url": "node/10326"
    },
    {
      "name": "Deen Muslim Indian Muslim Food Restaurant",
      "location": "1.3646711, 103.8903246",
      "vicinity": " Hougang Ave 3, #01-277 Blk 23, Singapore    S(530023)",
      "information": null,
      "terms": null,
      "number": null,
      "site": null,
      "photos": null,
      "videos": null,
      "url": "node/10326"
    },
    {
      "name": "D’Rubinah @ Punggol",
      "location": "1.392858, 103.917129",
      "vicinity": " 10 Tebing Ln, Singapore  Punggol  S(828849)",
      "information": null,
      "terms": null,
      "number": "6816 4989",
      "site": null,
      "photos": null,
      "videos": null,
      "url": "node/10326"
    },
    {
      "name": "E & D CO LOYANG POINT",
      "location": "1.3673096, 103.9647657",
      "vicinity": " 258, 01, 09 Pasir Ris Street 21, Loyang Point, Singapore  Pasir Ris  S(510258)",
      "information": null,
      "terms": null,
      "number": "6242 4152",
      "site": null,
      "photos": [""],
      "videos": null,
      "url": "node/10326"
    },
    {
      "name": "Eatz 19",
      "location": "1.3538186, 103.9407118",
      "vicinity": " #01-84 Tampines Walk, Our Tampines Hub, Singapore  Tampines  S(529684)",
      "information": "&lt;p&gt;Eatz 19 started in 1999 and was amongst the first to offer East &amp;amp; West cuisine fusion twist.&lt;br /&gt;\r\n&lt;br /&gt;\r\nIt has been our mission to ensure our recipes are carefully crafted with the best ingredients not compromising on quality, quantity and especially taste.&lt;/p&gt;\r\n",
      "terms": null,
      "number": "6222 2006",
      "site": null,
      "photos": [""],
      "videos": null,
      "url": "node/10326"
    },
    {
      "name": "Eatzi Gourmet Steakhouse & Bistro",
      "location": "1.3185822, 103.8928371",
      "vicinity": " 60 Paya Lebar Rd, #B1-15, Singapore  Paya Lebar  S(409051)",
      "information": "&lt;p&gt;Eatzi Gourmet is owned by the JP Pepperdine Group, the holding company that owns Jack’s Place Steakhouse and Restaurant Chain. Eatzi Gourmet was established in 1986 under the name of Jack’s Cake House, and quickly became renowned for their Signature Mango Mousse Cake. In 1992, Jack’s Cake House and Jack’s Place Catering moved to Jack’s Place Building which houses its head office, central kitchen and bakery at Defu Lane 10.&lt;/p&gt;\r\n\r\n&lt;p&gt;As Singapore’s society became more socially diverse and inclusive, the company decided to obtain Halal certification and rebranded Jack’s Cake House to Eatzi Gourmet in 2006. It also opened its first Halal-certified Eatzi Gourmet Steakhouse and Bistro in SAFRA Yishun in the same year.&lt;/p&gt;\r\n\r\n&lt;p&gt;Today, Eatzi Gourmet consists of three divisions –&amp;nbsp;&lt;strong&gt;&lt;a href=&quot;https://eatzigourmet.com.sg/steakhouse/bakery/&quot; rel=&quot;noopener noreferrer&quot; target=&quot;_blank&quot;&gt;Eatzi Gourmet Bakery&lt;/a&gt;,&amp;nbsp;&lt;a href=&quot;https://eatzigourmet.com.sg/steakhouse/catering&quot; rel=&quot;noopener noreferrer&quot; target=&quot;_blank&quot;&gt;Eatzi Gourmet Catering&amp;nbsp;&lt;/a&gt;&lt;/strong&gt;and&amp;nbsp;&lt;strong&gt;&lt;a href=&quot;https://eatzigourmet.com.sg/steakhouse/steakhouse&quot; rel=&quot;noopener noreferrer&quot; target=&quot;_blank&quot;&gt;Eatzi Gourmet Steakhouse &amp;amp; Bistro&lt;/a&gt;.&lt;/strong&gt;&amp;nbsp;Eatzi Gourmet Bakery offers a delightful range of cakes suitable for all occasions, while Eatzi Gourmet Catering provides a wide selection of Halal buffet packages that cater to different palates and budgets. Eatzi Gourmet Steakhouse &amp;amp; Bistro, the Halal-certified sibling restaurant of Jack’s Place, is committed to serving quality food and creating memorable dining experiences in a cheerful and cosy environment for our guests.&lt;/p&gt;\r\n",
      "terms": null,
      "number": "6341 6918",
      "site": null,
      "photos": [""],
      "videos": null,
      "url": "node/10326"
    },
    {
      "name": "Eatzi Gourmet Steakhouse & Bistro",
      "location": "1.424235, 103.840918",
      "vicinity": " 60, Yishun Ave 4, #01-01 SAFRA Yishun, Singapore  Yishun  S(769027)",
      "information": "&lt;p&gt;Eatzi Gourmet Steakhouse &amp;amp; Bistro, the Halal-certified sibling restaurant of Jack’s Place, is committed to serving quality food and creating memorable dining experiences in a cheerful and cosy environment for our guests.&lt;/p&gt;\r\n",
      "terms": null,
      "number": "6852 8270",
      "site": null,
      "photos": [""],
      "videos": null,
      "url": "node/10326"
    },
    {
      "name": "Eighteen Chefs JCUBE",
      "location": "1.333393, 103.74019",
      "vicinity": " 2 Jurong East Central 1, #02-13 JCube, Singapore  Jurong East  S(609731)",
      "information": "&lt;p&gt;Here at Eighteen Chefs, we strive to provide our customers with quality food at an affordable price – freshly prepared and fast every time! Without compromising our service standards, we hope you will enjoy yourself in our own unique ambience and be spoilt with a great variety of food choices.&lt;/p&gt;\r\n",
      "terms": null,
      "number": "6334 3606",
      "site": null,
      "photos": [""],
      "videos": null,
      "url": "node/10326"
    },
    {
      "name": "Elfuego by COLLIN’S®",
      "location": "1.3596548, 103.9896934",
      "vicinity": " 78 Airport Boulevard, Jewel #02 - 216, Singapore Changi Airport,  Changi  S(819666)",
      "information": "&lt;p&gt;Elfuego®, the newest halal concept by local western food chain COLLIN’S®, aims to redefine the dining experience for both local and international guests.&lt;br /&gt;\r\n&amp;nbsp;&lt;/p&gt;\r\n",
      "terms": null,
      "number": "6513 0716",
      "site": null,
      "photos": [""],
      "videos": null,
      "url": "node/10326"
    },
    {
      "name": "Empire Cuisine",
      "location": "1.372471, 103.866496",
      "vicinity": " 4 Ang Mo Kio Ind Park 2, Singapore  Ang Mo Kio  S(569498)",
      "information": "&lt;p&gt;Set in the heart of Singapore, at 4, Ang Mo Kio Ave 12, X Empire Cuisine resides.&lt;/p&gt;\r\n\r\n&lt;p&gt;Established in 1986 spanning two generations, we pride ourselves with great tasting food using the best quality ingredients we have been using since day one. We serve the vast multicultural customers who include people from adjacent neighbourhoods who crave for exemplary Indian food, may it be vegetarians or non-vegetarianswithout having the need to go to Serangoon Road (Tekka).Our Chefs have the ability to cook a variety of multicultural Cuisines such as South Indian, North Indian, Western, Oriental and Malay.&lt;/p&gt;\r\n\r\n&lt;p&gt;We cherish food. Deliberately picked flavors and herbs meet up in various scrumptious both vegan and non-veggie lover dishes. Take a gander at our menu to welcome the adaptability of conventions that mix up one’s taste buds and leave a waiting taste in one’s mouth.&lt;/p&gt;\r\n\r\n&lt;p&gt;With a Kitchen equipped to serve the needs of the daily restaurant business as well as to do catering for small to large events. Weddings, Corporate Functions, Conventions, and House Parties are just some of the capabilities of Empire Cuisine. We have a vast network of partnerships to support us at any event that we undertake.&lt;/p&gt;\r\n\r\n&lt;p&gt;What makes us different? We are constantly innovating, we are constantly improving, and our chic buffet setups are a feast to the eyes even before the food reaches the mouth. We go above and beyond to create a delightful memory that lasts for our clients.&lt;/p&gt;\r\n\r\n&lt;p&gt;Our motto, “We Conquer Your Tastebuds” signifies that we are well above the rest when it comes to taste. Being extraordinary and stylish is what makes us stand out among the crowd. Extravagant is what we will tell you when it comes to satisfying our customers mouth and stomach. The X Empire Cuisine experience is rich, fulfilling and absolutely enjoyable.&lt;/p&gt;\r\n\r\n&lt;p&gt;All said, bring yourselves down especially on Wednesdays and Saturdays to truly enjoy a scrumptious and decently priced meal, where our Culinary Director Chef S R Bala, holder of 2 Guinness World Records as well as numerous Singapore Book of Records recreates a memory that will take you back to your childhood days. His signature Fish Dum Briyani and Mutton Dum Briyani, will tingle in your tongues with all its richness, flavour and spice; a tradition passed down from generations.&lt;/p&gt;\r\n",
      "terms": null,
      "number": "9626 0942",
      "site": null,
      "photos": [""],
      "videos": null,
      "url": "node/10326"
    },
    {
      "name": "Fahzilaah Halal Food",
      "location": "1.285482, 103.821898",
      "vicinity": " Bukit Merah View, #01-52 115, Singapore  Bukit Merah  S(151115)",
      "information": null,
      "terms": null,
      "number": null,
      "site": null,
      "photos": null,
      "videos": null,
      "url": "node/10326"
    },
    {
      "name": "Flavour Flings",
      "location": "1.3538422, 103.8870254",
      "vicinity": " #01-1348 Hougang Ave 1, Block 121, Singapore  Hougang  S(530121)",
      "information": "&lt;p&gt;THE PLACE WHERE Singapore's NATIONWIDE SALTED EGG YOLK PHENOMENON STARTED.&lt;/p&gt;\r\n",
      "terms": null,
      "number": "6286 0051",
      "site": null,
      "photos": [""],
      "videos": null,
      "url": "node/10326"
    },
    {
      "name": "Golden Ladle",
      "location": "1.404009, 103.817497",
      "vicinity": " 33 Sembawang Rd, Singapore  Sembawang  S(779084)",
      "information": null,
      "terms": null,
      "number": "8102 9065",
      "site": null,
      "photos": null,
      "videos": null,
      "url": "node/10326"
    },
    {
      "name": "Grill Ninety Nine",
      "location": "1.3026, 103.858068",
      "vicinity": " 142 Arab St, Singapore    S(199828)",
      "information": "&lt;p&gt;Located conveniently near Bugis MRT at Arab Street, Grill Ninety Nine serves fine western cuisine that are mostly homemade and prepared with passion from our top-notch chef using halal certified ingredients.&lt;/p&gt;\r\n\r\n&lt;p&gt;Stay tuned to updates here and look out for our mouth-watering signature dishes as well as new items every now and then.&amp;nbsp;&lt;/p&gt;\r\n",
      "terms": null,
      "number": "9731 2902",
      "site": null,
      "photos": [""],
      "videos": null,
      "url": "node/10326"
    },
    {
      "name": "Haji Kadir Food Chains",
      "location": "1.3030913, 103.8639278",
      "vicinity": " 505 Beach Rd, #B1-13/14 Golden Mile Food Centre, Singapore    S(199583)",
      "information": "&lt;p&gt;&quot;HAJI KADIR FOOD CHAINS&quot; IS VERY FAMOUS IN GOLDEN MILE FOOD CENTRE STALL # B1-13/14 (SINGAPORE 199583) AND AT BLK 820 #01-534 TAMPINES ST.81 (SINGAPORE 520820) FOR ITS SUCCULENT TASTE OF THE SPECIALIZED SOUP TULANG. THE ATTRACTIVE FIERY-RED COLOUR MAKES YOU WANTED MORE AND CUSTOMERS ENJOY SUCKING THE BONE MARROW SO MUCH. MOST OF THE FOOD MAGAZINES EVEN ELECTED US AS THE BEST SOUP TULANG IN SINGAPORE.&lt;/p&gt;\r\n\r\n&lt;p&gt;OUR SOUP TULANG WAS ORIGINATED BY MY FATHER ABDUL KADIR IN THE 50'S. UNTIL TODAY, I STILL FOLLOWS CLOSELY TO MY FATHER’S RECIPE. CUSTOMERS LOVE OUR SOUP TULANG BECAUSE THE EXTERIOR MEAT AND TENDON ARE SOFT AND AROMATIC WHILE THE INTERIOR BONE MARROW IS TENDER AND SMOOTH. EATING SOUP TULANG ACTUALLY REQUIRE SOME SKILLS, OTHERWISE IT WILL DIRTY YOUR CLOTHES AND PUTTING YOURSELF LIKE A CLOWN. BUT THIS IS THE BEST INTEGRATION INTO THE LOCAL FOOD CULTURE AS IT WAS THE BEST SELF EXPERIENCE.&lt;/p&gt;\r\n\r\n&lt;p&gt;SOUP TULANG WAS SO POPULAR BECAUSE PEOPLE THINK IT HELPS IN NOURISHING BOTH MALE AND FEMALE REPRODUCTIVE SYSTEM. APART FROM THE SOUP TULANG, OTHER FAMOUS DISHES ARE MEE COMBO, MEE GORENG, NASI GORENG AYAM, MUTTON CHOP, MUTTON BISTIK,PRATA, MURTABA, BRIYANI, ROJAK, THAI SEAFOODS, ALL TASTE ABSOLUTELY GOOD, YOU REALLY GOT TO TRY ALL!&lt;/p&gt;\r\n",
      "terms": null,
      "number": "90047030",
      "site": null,
      "photos": null,
      "videos": null,
      "url": "node/10326"
    },
    {
      "name": "Hajjah Mariam Cafe",
      "location": "1.3344196, 103.7426504",
      "vicinity": " 3 Gateway Dr, #B2-08 Westgate Shopping Mall, Singapore  Jurong East  S(608532)",
      "information": "&lt;h2&gt;World of Nasi Ambeng&lt;/h2&gt;\r\n\r\n&lt;p&gt;&amp;nbsp;&lt;br /&gt;\r\n&lt;em&gt;What is Nasi Ambeng?&lt;/em&gt;&lt;/p&gt;\r\n\r\n&lt;p&gt;Nasi Ambeng is a fragrant rice dish consisting of white rice prepared with meat, vegetables, fried coconut flesh, Sambal Goreng as well as other dishes.&lt;/p&gt;\r\n\r\n&lt;p&gt;&lt;strong&gt;It’s a popular Javanese-Malay cuisine that’s normally seen during festivities and served on a tray and enjoyed together in a tray by up to 6 people.&lt;/strong&gt;&lt;/p&gt;\r\n\r\n&lt;p&gt;It is only natural to eat Nasi Ambeng by hand and it is supposed to signify togetherness and peace at meal times.&lt;/p&gt;\r\n\r\n&lt;p&gt;With Hajjah Mariam Café, you can savour this unique dish and many more mouth-watering local cuisine any time every time!&lt;/p&gt;\r\n\r\n&lt;p&gt;&lt;strong&gt;DINE IN. TAKE AWAY. SAVOUR&lt;/strong&gt;&lt;/p&gt;\r\n",
      "terms": null,
      "number": "9141 6629",
      "site": null,
      "photos": [""],
      "videos": null,
      "url": "node/10326"
    },
    {
      "name": "Halal-Take Away",
      "location": "1.302163, 103.858604",
      "vicinity": " 701 North Bridge Rd, Singapore    S(198677)",
      "information": null,
      "terms": null,
      "number": "9769 5158",
      "site": null,
      "photos": null,
      "videos": null,
      "url": "node/10326"
    },
    {
      "name": "Hawkerman @ The Seletar Mall",
      "location": "1.39131, 103.875894",
      "vicinity": "#02-14/15/16 33 Sengkang West Ave Seletar  S(797653)",
      "information": "&lt;p&gt;From crispy fried farm fresh spring chicken by Tenderfresh to delicious 60’s Hokkien Mee fried with the distinctive prawn broth, or the healthy stew of 7 key ingredients that makes up the Rainbow fillings; a heritage recipe handed down since 1977 to make our Good Chance’s Hokkien&amp;nbsp;popiah, Makcik&amp;nbsp;Sedap&amp;nbsp;Lemak &amp;amp; Asian Fusion Pasta,&amp;nbsp;there’s always something for everyone.&lt;/p&gt;\r\n",
      "terms": null,
      "number": "6243 6803",
      "site": null,
      "photos": [""],
      "videos": null,
      "url": "node/10326"
    },
    {
      "name": "Hi Five (Indian Muslim Food)",
      "location": "1.304202, 103.854458",
      "vicinity": " 6 Dunlop St, Singapore    S(209336)",
      "information": null,
      "terms": null,
      "number": null,
      "site": null,
      "photos": null,
      "videos": null,
      "url": "node/10326"
    },
    {
      "name": "Hjh Maimunah Restaurant and Catering",
      "location": "1.303175, 103.8585583",
      "vicinity": " 11 Jln Pisang, Singapore    S(199078)",
      "information": "&lt;p&gt;Hjh Maimunah Restaurant &amp;amp; Catering Pte Ltd, is a name familiar in relation to traditional, Kampung-styled cuisine. Established in the 90s, Hjh Maimunah Restaurant has since catered to customers from all walks of life in meeting their daily meals, functions and events. A meal at Hjh Maimunah Restaurant will indeed bring you back to the good old days of the rustic origin.&lt;/p&gt;\r\n\r\n&lt;p&gt;Apart from enjoying the food at our restaurants, we also provide buffet catering to suit your occasions. With a range of dishes that you can choose from, our food can be enjoyed right at your doorstep.&lt;/p&gt;\r\n\r\n&lt;p&gt;Here at Hjh Maimunah Restaurant, we are also known for our fine selection of Signature Dishes. One must try the delectable and Juicy Sundanese Grilled Chicken, the tempting Lemak Siput and the wide varieties of barbecued fish. Along with that, dishes such as Sambal Goreng, Tahu Telur, Beef Rendang and Oxtail Soup are among the more-than-40 selections that you can choose at our restaurants.&lt;/p&gt;\r\n\r\n&lt;p&gt;To end the fiesta, one should not miss the array of mouth-watering traditional Kuihs and Desserts available.&lt;/p&gt;\r\n",
      "terms": null,
      "number": "6297 4294",
      "site": null,
      "photos": [""],
      "videos": null,
      "url": "node/10326"
    },
    {
      "name": "Home of Seafood",
      "location": "1.313335, 103.899752",
      "vicinity": " 1 Joo Chiat Pl, Singapore    S(427739)",
      "information": "&lt;p&gt;Singapore authentic Chinese seafood restaurant.&amp;nbsp;In partnership with the renowned House Of Seafood&lt;br /&gt;\r\nHalal Chinese Seafood&lt;/p&gt;\r\n",
      "terms": null,
      "number": "6442 5180",
      "site": null,
      "photos": [""],
      "videos": null,
      "url": "node/10326"
    },
    {
      "name": "IndoChili",
      "location": "1.292934, 103.831197",
      "vicinity": " 54 Zion Rd, Singapore  River Valley  S(247779)",
      "information": "&lt;p&gt;From the winner of Food Republic Hawker King Challenge and one of the rare restaurants rated 4-5 out of 5 by 8 Days Magazine, Java Kitchen Group presents:&amp;nbsp;&lt;br /&gt;\r\n&lt;br /&gt;\r\nIndoChili – the latest urban oasis of food for your soul!&lt;/p&gt;\r\n",
      "terms": null,
      "number": "6445 1766",
      "site": null,
      "photos": [""],
      "videos": null,
      "url": "node/10326"
    },
    {
      "name": "IndoChili @ Science Park",
      "location": "1.291175, 103.784435",
      "vicinity": " 2 Science Park Dr, #01-09 Ascent, Singapore, Singapore  Queenstown  S(118222)",
      "information": "&lt;p&gt;We have&amp;nbsp; scoured Indonesia in search of the best tasting dishes that the country has to offer. We pride ourselves in using only the finest ingredients in all our recipes with no MSG added.&lt;br /&gt;\r\n&lt;br /&gt;\r\nEvery meal is carefully prepared with traditional Indonesian cooking philosophy. Our extensive menu will&amp;nbsp; sure to please even the most discerning palate. At IndoChili we offer authentic Indonesian cuisine mostly from Java, Padang, and Bali. We invite&amp;nbsp; you to taste the best of Indonesia!&lt;/p&gt;\r\n",
      "terms": null,
      "number": "6909 0177",
      "site": null,
      "photos": [""],
      "videos": null,
      "url": "node/10326"
    },
    {
      "name": "Jalan Kayu The Prata Cafe - Tai Seng",
      "location": "1.336013, 103.889202",
      "vicinity": " 18 Tai Seng St, #01-29, Singapore    S(539775)",
      "information": null,
      "terms": null,
      "number": "6384 5128",
      "site": null,
      "photos": null,
      "videos": null,
      "url": "node/10326"
    },
    {
      "name": "Julaiha Muslim Restaurant",
      "location": "1.3323758, 103.8846207",
      "vicinity": " 538 MacPherson Rd, Singapore    S(368222)",
      "information": null,
      "terms": null,
      "number": "6743 2773",
      "site": null,
      "photos": [""],
      "videos": null,
      "url": "node/10326"
    },
    {
      "name": "Kampong Chai Chee Restaurant",
      "location": "1.3182423, 103.9074661",
      "vicinity": " 303 Changi Rd, Singapore  Changi  S(419781)",
      "information": "&lt;p&gt;Kampong Chai Chee Restaurant, established in 1988, is a brand name that is associated with quality halal seafood prepared in truly Asian culinary styles.&lt;br /&gt;\r\n&lt;br /&gt;\r\nFormerly at Tampines Telepark, we re-located to 303 Changi Road, a premise that offers a perfect meeting ground for Muslim and non-Muslim customers to enjoy local food in a relaxed atmosphere.&lt;br /&gt;\r\n&lt;br /&gt;\r\nWe have maintained our traditional “Zhi Char” style with our own unique touch of Kampong Chai Chee Restaurant flavour that is recognised by many customers&amp;nbsp;Our range of food has also expanded to include the now very popular Shell-Out as well as Western Food.&lt;/p&gt;\r\n",
      "terms": null,
      "number": "6841 5005",
      "site": null,
      "photos": [""],
      "videos": null,
      "url": "node/10326"
    },
    {
      "name": "King Omar Indian Muslim food & Thai seafood",
      "location": "1.3393108, 103.8490808",
      "vicinity": " Lor 4 Toa Payoh, Block 95, Singapore    S(310095)",
      "information": null,
      "terms": null,
      "number": null,
      "site": null,
      "photos": null,
      "videos": null,
      "url": "node/10326"
    },
    {
      "name": "Koufu",
      "location": "1.3673522, 103.9647895",
      "vicinity": " Loyang Point Blk 258 #02-313, Pasir Ris Street 21, Singapore  Pasir Ris  S(510258)",
      "information": "&lt;p&gt;“Koufu” refers to the Chinese belief that it is one’s good fortune to feast on good food.&lt;br /&gt;\r\n&lt;br /&gt;\r\nSince our establishment in 2002, we have held this same belief. To bring forth ‘Koufu’ to everyone, we make it our mission to provide good food and services that everyone is able to enjoy through our deep roots in traditional Singaporean cooking and in true coffee shop tradition.&lt;br /&gt;\r\n&lt;br /&gt;\r\nWe adopt this comprehensive approach to provide such good fortune for generations of loyal customers.&lt;br /&gt;\r\n&lt;br /&gt;\r\nKoufu’s logo represents the company’s commitment to making a difference to the well being of everyone through its food services.&lt;/p&gt;\r\n",
      "terms": null,
      "number": "6506 0161",
      "site": null,
      "photos": [""],
      "videos": null,
      "url": "node/10326"
    },
    {
      "name": "Kucina Italian Restaurant",
      "location": "1.3149868, 103.8946433",
      "vicinity": " 11 Tanjong Katong Rd, #B1-09/10, KINEX    S(437157)",
      "information": "&lt;p&gt;Kucina is the FIRST and ONLY authentic Italian restaurant and caterer that is MUIS Halal certified. Helmed by Chef Gero, an Italian-Muslim revert who has close to 30 years of experience under his belt.&lt;br /&gt;\r\n&lt;br /&gt;\r\nKUCINA, which means KITCHEN in Italian, is a 100% Muslim-owned Italian restaurant serving Halal Italian cuisines. The restaurant is founded by a highly experienced Italian Muslim chef and his Indian Muslim partner. The chef has been in the F&amp;amp;B industry for over 24 years, specializing in Italian cuisine. KUCINA aims to provide authentic and high quality Italian food to its customers, both Muslims and non-Muslims alike. Now Muslim customers can enjoy delicious Italian dish such as Gnocchi (melt-in-the-mouth potato dumplings in salmon sauce). Price range is from $4-$23 (excluding service charge). Don't forget to order our mouth-watering desserts, tortino (chocolate lava cake), tiramisu nutella, pannacotta, chocolate orange cheesecake, on your next visit.&lt;br /&gt;\r\n&lt;br /&gt;\r\nNo time to dine at KUCINA? No worries..we'll bring KUCINA dishes to you via DELIVEROO and FOOD PANDA (for those staying around Katong area).&lt;br /&gt;\r\n&lt;br /&gt;\r\n&amp;nbsp;&lt;/p&gt;\r\n",
      "terms": null,
      "number": "6493 2154",
      "site": null,
      "photos": [""],
      "videos": null,
      "url": "node/10326"
    },
    {
      "name": "L.K Maju Restaurant Pte. Ltd.",
      "location": "1.308603, 103.855026",
      "vicinity": " 51 Rowell Rd, Singapore    S(207999)",
      "information": null,
      "terms": null,
      "number": "6299 5990",
      "site": null,
      "photos": null,
      "videos": null,
      "url": "node/10326"
    },
    {
      "name": "Little Myanmar Halal Foods",
      "location": "1.313511, 103.766986",
      "vicinity": " #01-220 Blk328,Clementi Ave 2 Singapore  Clementi  S(120328)",
      "information": "&lt;p&gt;Halal Myanmar Favourite Foods Concept&lt;br /&gt;\r\n“Myanmar Food “&lt;br /&gt;\r\n“Chinese Muslim Food”&lt;br /&gt;\r\n“Local delight&lt;/p&gt;\r\n",
      "terms": null,
      "number": null,
      "site": null,
      "photos": [""],
      "videos": null,
      "url": "node/10326"
    },
    {
      "name": "Lukhon Thai",
      "location": "1.3733948, 103.9515152",
      "vicinity": " 110 Pasir Ris Central Hawker Centre, #02-05, Singapore  Pasir Ris  S(519641)",
      "information": "&lt;p&gt;Halal Thai BBQ &amp;amp; Steamboat. Come try our authentic Northern Thai meat marinates and delicious chilli dip. Now at the new Pasir Ris Central Hawker Centre!&lt;/p&gt;\r\n",
      "terms": null,
      "number": " 9675 5849",
      "site": null,
      "photos": [""],
      "videos": null,
      "url": "node/10326"
    },
    {
      "name": "Ma Mum",
      "location": "1.338611, 103.983056",
      "vicinity": " Level 1 Public Area, 10 Airport Blvd, Singapore Changi Airport, Terminal 4, Singapore    S(819665)",
      "information": null,
      "terms": null,
      "number": null,
      "site": null,
      "photos": null,
      "videos": null,
      "url": "node/10326"
    },
    {
      "name": "MacKenzie Rex Restaurant",
      "location": "1.299893, 103.849966",
      "vicinity": " 66 Prinsep St, Singapore    S(188668)",
      "information": "&lt;p&gt;Established in Singapore in 1966, MacKenzie Rex restaurant is a fine&amp;nbsp;&lt;strong&gt;Oriental Halal Restaurant&lt;/strong&gt;&amp;nbsp;who has served many generations. With over a hundred dishes, ranging from all-time favourites such as Hainanese Chicken Rice, Spring Rolls, Sweet Sour Garoupa, you will be spoilt for choices.&lt;/p&gt;\r\n",
      "terms": null,
      "number": "6336 1702",
      "site": null,
      "photos": [""],
      "videos": null,
      "url": "node/10326"
    },
    {
      "name": "Maisal Nasi Padang",
      "location": "1.354163, 103.877534",
      "vicinity": " 1J Yio Chu Kang Rd, Singapore    S(545515)",
      "information": null,
      "terms": null,
      "number": "6285 0841",
      "site": null,
      "photos": null,
      "videos": null,
      "url": "node/10326"
    },
    {
      "name": "Malay muslim halal stall @ superluck food court (bus interchange food court)",
      "location": "1.3709091, 103.8932288",
      "vicinity": " 840 Hougang Central, Singapore    S(538757)",
      "information": null,
      "terms": null,
      "number": null,
      "site": null,
      "photos": null,
      "videos": null,
      "url": "node/10326"
    },
    {
      "name": "Marhaba Murtabak Restaurant",
      "location": "1.3163864, 103.8992615",
      "vicinity": " 52 Changi Rd, Singapore  Changi  S(419707)",
      "information": null,
      "terms": null,
      "number": "6344 5518",
      "site": null,
      "photos": null,
      "videos": null,
      "url": "node/10326"
    },
    {
      "name": "McDonald's Loyang Point",
      "location": "1.3667334, 103.964141",
      "vicinity": " 258 Pasir Ris Street 21 #01-25 Loyang Point, Singapore  Pasir Ris  S(510258)",
      "information": null,
      "terms": null,
      "number": "6777 3777",
      "site": null,
      "photos": [""],
      "videos": null,
      "url": "node/10326"
    },
    {
      "name": "Mohd Zaid",
      "location": "1.286829, 103.80816",
      "vicinity": " 1 Jalan Bukit Merah, Singapore    S(150001)",
      "information": null,
      "terms": null,
      "number": null,
      "site": null,
      "photos": null,
      "videos": null,
      "url": "node/10326"
    },
    {
      "name": "Mr Muniz (Indian Muslim Food)",
      "location": "1.354718, 103.960524",
      "vicinity": " 27 Tampines Street 34, Singapore  Tampines  S(529235)",
      "information": null,
      "terms": null,
      "number": null,
      "site": null,
      "photos": null,
      "videos": null,
      "url": "node/10326"
    },
    {
      "name": "Mr Teh Tarik (Jurong 492)",
      "location": "1.350752, 103.720264",
      "vicinity": " 456 Jurong West Ave 1, Singapore  Jurong West  S(640301)",
      "information": null,
      "terms": null,
      "number": null,
      "site": null,
      "photos": null,
      "videos": null,
      "url": "node/10326"
    },
    {
      "name": "Mr Teh Tarik Eating House",
      "location": "1.3723303, 103.8457711",
      "vicinity": " 728 Ang Mo Kio Ave 6, Singapore  Ang Mo Kio  S(560728)",
      "information": null,
      "terms": null,
      "number": null,
      "site": null,
      "photos": null,
      "videos": null,
      "url": "node/10326"
    },
    {
      "name": "Mufiz Prata Corner Pte Ltd",
      "location": "1.312244, 103.878036",
      "vicinity": " Lor 12 Geylang, Singapore  Geylang  S(398993)",
      "information": null,
      "terms": null,
      "number": null,
      "site": null,
      "photos": null,
      "videos": null,
      "url": "node/10326"
    },
    {
      "name": "Mufiz Restaurant Pte Ltd",
      "location": "1.3159893, 103.8833056",
      "vicinity": " 80 Lor 25A Geylang, Singapore  Geylang  S(388260)",
      "information": null,
      "terms": null,
      "number": null,
      "site": null,
      "photos": null,
      "videos": null,
      "url": "node/10326"
    },
    {
      "name": "Mufiz Restaurant Pte Ltd (Halal Food)",
      "location": "1.366513, 103.841474",
      "vicinity": " 215 Ang Mo Kio Ave 1, #01-885, Singapore  Ang Mo Kio  S(560215)",
      "information": null,
      "terms": null,
      "number": null,
      "site": null,
      "photos": null,
      "videos": null,
      "url": "node/10326"
    },
    {
      "name": "Mukshidonna",
      "location": "1.3772422, 103.9549722",
      "vicinity": " 1 Pasir Ris Cl, Singapore  Pasir Ris  S(519599)",
      "information": "&lt;p&gt;Mukshidonna is commonly known to serve delicious Budae Jjigae, they have branded themselves as a “Toppoki” restaurant.&lt;br /&gt;\r\n&lt;br /&gt;\r\nMukshidonna has also arrived in Singapore with its first outlet located at Downtown East, Pasir Ris.&lt;br /&gt;\r\n&lt;br /&gt;\r\nThe term Muk-shi-don-na means Eat (Muk), Rest (Shi), Pay (Don), Leave (Na) when translated in English, meaning “Have your food, pay and leave”.&lt;/p&gt;\r\n",
      "terms": null,
      "number": "8667 3380",
      "site": null,
      "photos": [""],
      "videos": null,
      "url": "node/10326"
    },
    {
      "name": "Muslim Delights Malay Food and Noodles",
      "location": "1.338261, 103.886618",
      "vicinity": " 117 Upper Paya Lebar Rd, Singapore    S(534834)",
      "information": null,
      "terms": null,
      "number": null,
      "site": null,
      "photos": null,
      "videos": null,
      "url": "node/10326"
    },
    {
      "name": "My Spice Affair",
      "location": "1.3103444, 103.8641272",
      "vicinity": " 12 Kallang Ave, #02-11, Singapore    S(339512)",
      "information": null,
      "terms": null,
      "number": null,
      "site": null,
      "photos": null,
      "videos": null,
      "url": "node/10326"
    },
    {
      "name": "Nasi Lemak Ayam Taliwang - Hougang",
      "location": "1.375666, 103.883087",
      "vicinity": " 51 Hougang Ave 9, Stall #01-40, Singapore    S(538776)",
      "information": null,
      "terms": null,
      "number": null,
      "site": null,
      "photos": null,
      "videos": null,
      "url": "node/10326"
    },
    {
      "name": "New Shah Alam Restaurant (Halal)",
      "location": "1.287311, 103.8489298",
      "vicinity": " 20-21 Circular Rd, Singapore    S(49376)",
      "information": null,
      "terms": null,
      "number": null,
      "site": null,
      "photos": null,
      "videos": null,
      "url": "node/10326"
    },
    {
      "name": "Pasir Ris Central Hawker Centre",
      "location": "1.3734951, 103.9513942",
      "vicinity": " 110 Central Hawker Centre, Singapore    S(519639)",
      "information": null,
      "terms": null,
      "number": null,
      "site": null,
      "photos": null,
      "videos": null,
      "url": "node/10326"
    },
    {
      "name": "Penang Culture",
      "location": "1.332978, 103.743519",
      "vicinity": " 50 Jurong Gateway Rd, #04 - 27, Singapore    S(608549)",
      "information": null,
      "terms": null,
      "number": null,
      "site": null,
      "photos": null,
      "videos": null,
      "url": "node/10326"
    },
    {
      "name": "Penang Culture",
      "location": "1.3724908, 103.9496212",
      "vicinity": " 1 Pasir Ris Central Street 3, #03 - 21, Singapore    S(518457)",
      "information": null,
      "terms": null,
      "number": null,
      "site": null,
      "photos": null,
      "videos": null,
      "url": "node/10326"
    },
    {
      "name": "Pistachio Middle Eastern & Mediterranean Grill",
      "location": "1.3047411, 103.8305926",
      "vicinity": " 501 Orchard Rd, #02-04/05 Wheelock Place, Singapore    S(238880)",
      "information": null,
      "terms": null,
      "number": null,
      "site": null,
      "photos": null,
      "videos": null,
      "url": "node/10326"
    },
    {
      "name": "Pondok Makan Indonesia",
      "location": "1.3012845, 103.8538526",
      "vicinity": " 270 Queen St, Singapore    S(180270)",
      "information": null,
      "terms": null,
      "number": null,
      "site": null,
      "photos": null,
      "videos": null,
      "url": "node/10326"
    },
    {
      "name": "Positano Risto",
      "location": "1.3011061, 103.8598717",
      "vicinity": " 66 Bussorah St, Singapore    S(199479)",
      "information": null,
      "terms": null,
      "number": null,
      "site": null,
      "photos": null,
      "videos": null,
      "url": "node/10326"
    },
    {
      "name": "Qtech Cafe Halal Restaurant",
      "location": "1.307781, 103.857714",
      "vicinity": " 211 Syed Alwi Rd, Singapore    S(207744)",
      "information": null,
      "terms": null,
      "number": null,
      "site": null,
      "photos": null,
      "videos": null,
      "url": "node/10326"
    },
    {
      "name": "Rasa Istimewa Restaurant @ Pasir Ris",
      "location": "1.3821322, 103.9478907",
      "vicinity": " 201 Pasir Ris Rd, Singapore    S(519147)",
      "information": null,
      "terms": null,
      "number": null,
      "site": null,
      "photos": null,
      "videos": null,
      "url": "node/10326"
    },
    {
      "name": "Rasa Rasa @ Yishun",
      "location": "1.426559, 103.842904",
      "vicinity": " 348 Yishun Ave 11, Singapore    S(760348)",
      "information": null,
      "terms": null,
      "number": null,
      "site": null,
      "photos": null,
      "videos": null,
      "url": "node/10326"
    },
    {
      "name": "Rasa Rasa Restaurant",
      "location": "1.380426, 103.757089",
      "vicinity": " 160A Jln Teck Whye, Singapore    S(681160)",
      "information": null,
      "terms": null,
      "number": null,
      "site": null,
      "photos": null,
      "videos": null,
      "url": "node/10326"
    },
    {
      "name": "Rasa Sayang Village",
      "location": "1.389699, 103.986646",
      "vicinity": " 5 Changi Village Rd, #01-2063, Singapore    S(500005)",
      "information": null,
      "terms": null,
      "number": null,
      "site": null,
      "photos": null,
      "videos": null,
      "url": "node/10326"
    },
    {
      "name": "Royal Palm @ Orchid Country Club Restaurant",
      "location": "1.410996, 103.84432",
      "vicinity": " 1 Orchid Club Road, #01-21/22, Social Clubhouse, Singapore    S(769162)",
      "information": null,
      "terms": null,
      "number": null,
      "site": null,
      "photos": null,
      "videos": null,
      "url": "node/10326"
    },
    {
      "name": "Saap Saap Thai",
      "location": "1.3537611, 103.9407278",
      "vicinity": " #01-100, Our Tampines Hub, 51 Tampines Ave 4, Singapore    S(529684)",
      "information": null,
      "terms": null,
      "number": null,
      "site": null,
      "photos": null,
      "videos": null,
      "url": "node/10326"
    },
    {
      "name": "Sakura",
      "location": "1.342373, 103.953166",
      "vicinity": " 3 Simei Street 6, #03-05 Eastpoint Mall, Singapore    S(528833)",
      "information": null,
      "terms": null,
      "number": null,
      "site": null,
      "photos": null,
      "videos": null,
      "url": "node/10326"
    },
    {
      "name": "Sedap",
      "location": "1.3410146, 103.9484796",
      "vicinity": " 6 Simei Street 3, Singapore    S(529898)",
      "information": null,
      "terms": null,
      "number": null,
      "site": null,
      "photos": null,
      "videos": null,
      "url": "node/10326"
    },
    {
      "name": "Sedap Noodle",
      "location": "1.313468, 103.765017",
      "vicinity": " Clementi Ave 3, #01-211 Blk 449, Singapore    S(120449)",
      "information": null,
      "terms": null,
      "number": null,
      "site": null,
      "photos": null,
      "videos": null,
      "url": "node/10326"
    },
    {
      "name": "Sedap Noodle",
      "location": "1.33997, 103.742181",
      "vicinity": " Jurong East Street 21, #01-320 Block 235, Singapore    S(600235)",
      "information": null,
      "terms": null,
      "number": null,
      "site": null,
      "photos": null,
      "videos": null,
      "url": "node/10326"
    },
    {
      "name": "Segar @ Downtown East",
      "location": "1.377274, 103.954988",
      "vicinity": " 1 Pasir Ris Close, Market Square, #02-322 E! Avenue @ Downtown East, Singapore    S(519599)",
      "information": null,
      "terms": null,
      "number": null,
      "site": null,
      "photos": null,
      "videos": null,
      "url": "node/10326"
    },
    {
      "name": "Selera Nasi Padang",
      "location": "1.289597, 103.817057",
      "vicinity": " 920 Tiong Bahru Rd, #01-11, Singapore    S(158792)",
      "information": null,
      "terms": null,
      "number": null,
      "site": null,
      "photos": null,
      "videos": null,
      "url": "node/10326"
    },
    {
      "name": "SG Royal Foods Restaurant",
      "location": "1.3543102, 103.8789608",
      "vicinity": " 768 Upper Serangoon Rd, Singapore    S(534636)",
      "information": null,
      "terms": null,
      "number": null,
      "site": null,
      "photos": null,
      "videos": null,
      "url": "node/10326"
    },
    {
      "name": "Shafiq Halal Food",
      "location": "1.354232, 103.960119",
      "vicinity": " 9 Tampines Street 32, Singapore    S(529286)",
      "information": null,
      "terms": null,
      "number": null,
      "site": null,
      "photos": null,
      "videos": null,
      "url": "node/10326"
    },
    {
      "name": "Sheikh Indian Pakistani Food",
      "location": "1.283212, 103.816779",
      "vicinity": " 164 Bukit Merah Central, #01-3631, Singapore    S(150164)",
      "information": null,
      "terms": null,
      "number": null,
      "site": null,
      "photos": null,
      "videos": null,
      "url": "node/10326"
    },
    {
      "name": "Spize Rifle Range @ Temasek Club",
      "location": "1.346402, 103.780639",
      "vicinity": " 131 Rifle Range Rd, #03-04, Singapore    S(588406)",
      "information": null,
      "terms": null,
      "number": "6337 7493",
      "site": null,
      "photos": null,
      "videos": null,
      "url": "node/10326"
    },
    {
      "name": "StraitsKitchen",
      "location": "1.3062611, 103.8333999",
      "vicinity": " 10 Scotts Road Grand Hyatt, Singapore    S(228211)",
      "information": null,
      "terms": null,
      "number": "6732 1234",
      "site": null,
      "photos": null,
      "videos": null,
      "url": "node/10326"
    },
    {
      "name": "Subway",
      "location": "1.3668286, 103.9646253",
      "vicinity": " 258 Pasir Ris Street 21, #01-16, Singapore    S(510258)",
      "information": null,
      "terms": null,
      "number": null,
      "site": null,
      "photos": null,
      "videos": null,
      "url": "node/10326"
    },
    {
      "name": "Tang Tea House",
      "location": "1.397763, 103.873341",
      "vicinity": " 242 Jln Kayu, Singapore    S(799466)",
      "information": null,
      "terms": null,
      "number": null,
      "site": null,
      "photos": null,
      "videos": null,
      "url": "node/10326"
    },
    {
      "name": "Tang Tea House",
      "location": "1.390207, 103.987838",
      "vicinity": " 57 Lor Bekukong, Singapore    S(499173)",
      "information": null,
      "terms": null,
      "number": null,
      "site": null,
      "photos": null,
      "videos": null,
      "url": "node/10326"
    },
    {
      "name": "Tenderfresh Classic @ Cheong Chin Nam",
      "location": "1.34278, 103.7750891",
      "vicinity": " 9 Cheong Chin Nam Rd, Singapore    S(599734)",
      "information": null,
      "terms": null,
      "number": null,
      "site": null,
      "photos": null,
      "videos": null,
      "url": "node/10326"
    },
    {
      "name": "Tenderfresh Classic @ Our Tampines Hub",
      "location": "1.3538475, 103.9408083",
      "vicinity": " 1 Tampines Walk, #01-102, Singapore    S(528523)",
      "information": null,
      "terms": null,
      "number": null,
      "site": null,
      "photos": null,
      "videos": null,
      "url": "node/10326"
    },
    {
      "name": "Tenderfresh Pasta & Broiler",
      "location": "1.3666058, 103.9643757",
      "vicinity": " #01-21 Loyang Point, 258 Pasir Ris Street 21, Singapore    S(510258)",
      "information": null,
      "terms": null,
      "number": null,
      "site": null,
      "photos": null,
      "videos": null,
      "url": "node/10326"
    },
    {
      "name": "The Dim Sum Place",
      "location": "1.303976, 103.860148",
      "vicinity": " 791 North Bridge Rd, Singapore    S(198759)",
      "information": null,
      "terms": null,
      "number": null,
      "site": null,
      "photos": null,
      "videos": null,
      "url": "node/10326"
    },
    {
      "name": "The Halal Corner",
      "location": "1.334, 103.928221",
      "vicinity": " Bedok North Street 3, Block 527, Singapore    S(460527)",
      "information": null,
      "terms": null,
      "number": null,
      "site": null,
      "photos": null,
      "videos": null,
      "url": "node/10326"
    },
    {
      "name": "The MeatHouse by 18Chefs",
      "location": "1.3524648, 103.9437496",
      "vicinity": " 2 Tampines Central 5, #05-04, Singapore    S(529509)",
      "information": null,
      "terms": null,
      "number": null,
      "site": null,
      "photos": null,
      "videos": null,
      "url": "node/10326"
    },
    {
      "name": "The Ramen Stall",
      "location": "1.3038665, 103.8600133",
      "vicinity": " 787 North Bridge Rd, Singapore    S(198755)",
      "information": null,
      "terms": null,
      "number": null,
      "site": null,
      "photos": null,
      "videos": null,
      "url": "node/10326"
    },
    {
      "name": "The Royals Steakhouse",
      "location": "1.303311, 103.858706",
      "vicinity": " 10 Jln Pisang, Singapore    S(199077)",
      "information": null,
      "terms": null,
      "number": null,
      "site": null,
      "photos": null,
      "videos": null,
      "url": "node/10326"
    },
    {
      "name": "The Shepherd's Pie - Baking Since 2007 - Halal Certified",
      "location": "1.336877, 103.947503",
      "vicinity": " Blk 3015 Bedok North St 5 #06-05 (Passenger, Lift, Lobby 2, Singapore    S(486350)",
      "information": null,
      "terms": null,
      "number": null,
      "site": null,
      "photos": null,
      "videos": null,
      "url": "node/10326"
    },
    {
      "name": "Time For Thai SG",
      "location": "1.343192, 103.774994",
      "vicinity": " 15 Cheong Chin Nam Rd, Singapore    S(599739)",
      "information": null,
      "terms": null,
      "number": null,
      "site": null,
      "photos": null,
      "videos": null,
      "url": "node/10326"
    },
    {
      "name": "Tongue Tip Lanzhou Beef Noodles",
      "location": "1.33927, 103.705181",
      "vicinity": " 63, #03-105 Jurong West Central 3, Jurong Point, Singapore    S(648331)",
      "information": null,
      "terms": null,
      "number": null,
      "site": null,
      "photos": null,
      "videos": null,
      "url": "node/10326"
    },
    {
      "name": "Wanderlost Lounge - By The Halal Mixologist",
      "location": "1.2740967, 103.8441783",
      "vicinity": " Realty Centre, 15 Enggor Street #12-01 12th floor,    S(79716)",
      "information": null,
      "terms": null,
      "number": null,
      "site": null,
      "photos": null,
      "videos": null,
      "url": "node/10326"
    },
    {
      "name": "West Co'z Cafe",
      "location": "1.3035814, 103.7658606",
      "vicinity": " 154 W Coast Rd #02-23 West Coast Plaza,    S(127371)",
      "information": null,
      "terms": null,
      "number": null,
      "site": null,
      "photos": null,
      "videos": null,
      "url": "node/10326"
    },
    {
      "name": "WOK HEY Hougang Mall",
      "location": "1.372148, 103.893717",
      "vicinity": " 90 Hougang Avenue 10 #01-40 Hougang Mall, Singapore    S(538766)",
      "information": null,
      "terms": null,
      "number": null,
      "site": null,
      "photos": null,
      "videos": null,
      "url": "node/10326"
    },
    {
      "name": "Yakkoap's Curry",
      "location": "1.328095, 103.885281",
      "vicinity": " 78 Circuit Rd, Block 78, Singapore    S(370078)",
      "information": null,
      "terms": null,
      "number": null,
      "site": null,
      "photos": null,
      "videos": null,
      "url": "node/10326"
    },
    {
      "name": "Yasimah Muslim Food",
      "location": "1.3814636, 103.7644438",
      "vicinity": " 101 Bukit Panjang Rd, Singapore    S(670534)",
      "information": null,
      "terms": null,
      "number": null,
      "site": null,
      "photos": null,
      "videos": null,
      "url": "node/10326"
    },
    {
      "name": "Yassin Kampung @ Bedok",
      "location": "1.325932, 103.933358",
      "vicinity": " 215 Bedok North Street 1, Singapore    S(460215)",
      "information": null,
      "terms": null,
      "number": null,
      "site": null,
      "photos": null,
      "videos": null,
      "url": "node/10326"
    },
    {
      "name": "Yassin Kampung @ Marsiling",
      "location": "1.446171, 103.773697",
      "vicinity": " 210 Marsiling Cres, #01-01, Singapore    S(730210)",
      "information": null,
      "terms": null,
      "number": null,
      "site": null,
      "photos": null,
      "videos": null,
      "url": "node/10326"
    },
    {
      "name": "Yi Zun Noodle",
      "location": "1.309719, 103.856409",
      "vicinity": " 45 Sam Leong Rd, Singapore    S(207935)",
      "information": null,
      "terms": null,
      "number": null,
      "site": null,
      "photos": null,
      "videos": null,
      "url": "node/10326"
    },
    {
      "name": "Zilan Nasi Ayam",
      "location": "1.374178, 103.88683",
      "vicinity": " 01-1348 Hougang Park Food Station, Hougang Ave 8, Blk 684, Singapore    S(530684)",
      "information": null,
      "terms": null,
      "number": null,
      "site": null,
      "photos": null,
      "videos": null,
      "url": "node/10326"
    },
    {
      "name": "21 On Rajah",
      "location": "1.327048, 103.847462",
      "vicinity": " 1 Jln Rajah, Singapore    S(329133)",
      "information": null,
      "terms": null,
      "number": null,
      "site": null,
      "photos": null,
      "videos": null,
      "url": "node/13083"
    },
    {
      "name": "AL HABIB INDIAN MUSLIM FOOD",
      "location": "1.4523966, 103.8175192",
      "vicinity": " Sembawang Dr, #01-01, SINGAPORE 751406 BLK 406A, Singapore    S(751406)",
      "information": null,
      "terms": null,
      "number": null,
      "site": null,
      "photos": null,
      "videos": null,
      "url": "node/13083"
    },
    {
      "name": "AL HABIB INDIAN MUSLIM FOOD",
      "location": "1.4504546, 103.7965604",
      "vicinity": " 200 Woodlands Ind Park E7, #01-40, Singapore    S(757177)",
      "information": null,
      "terms": null,
      "number": null,
      "site": null,
      "photos": null,
      "videos": null,
      "url": "node/13083"
    },
    {
      "name": "AL HABIB INDIAN MUSLIM FOOD",
      "location": "1.436551, 103.842973",
      "vicinity": " 2 Yishun Industrial Street 1, #01-12 Northpoint Bizhub, Singapore    S(768159)",
      "information": null,
      "terms": null,
      "number": null,
      "site": null,
      "photos": null,
      "videos": null,
      "url": "node/13083"
    },
    {
      "name": "AL HABIB INDIAN MUSLIM FOOD",
      "location": "1.430771, 103.790939",
      "vicinity": " BLK 570A, WOODLANDS AVE 1, #01-01, SINGAPORE 731570, CHAMPIONS COURT,    S(731570)",
      "information": null,
      "terms": null,
      "number": null,
      "site": null,
      "photos": null,
      "videos": null,
      "url": "node/13083"
    },
    {
      "name": "AL HABIB INDIAN MUSLIM FOOD",
      "location": "1.4035452, 103.9062284",
      "vicinity": " 301 Punggol Central, #01-06, Singapore    S(820301)",
      "information": null,
      "terms": null,
      "number": null,
      "site": null,
      "photos": null,
      "videos": null,
      "url": "node/13083"
    },
    {
      "name": "AL HABIB INDIAN MUSLIM FOOD",
      "location": "1.430771, 103.790939",
      "vicinity": " BLK 570A, WOODLANDS AVE 1, #01-01, SINGAPORE 731570, CHAMPIONS COURT, Singapore    S(731570)",
      "information": null,
      "terms": null,
      "number": null,
      "site": null,
      "photos": null,
      "videos": null,
      "url": "node/13083"
    },
    {
      "name": "Encik Tan",
      "location": "1.34273, 103.953018",
      "vicinity": " 3 Simei Street 6, #B1-12, Singapore    S(528833)",
      "information": null,
      "terms": null,
      "number": null,
      "site": null,
      "photos": null,
      "videos": null,
      "url": "node/13083"
    },
    {
      "name": "Encik Tan",
      "location": "1.30359, 103.87256",
      "vicinity": " #01-32 Kallang Wave Mall, 1 Stadium Pl, Singapore    S(397628)",
      "information": null,
      "terms": null,
      "number": null,
      "site": null,
      "photos": null,
      "videos": null,
      "url": "node/13083"
    },
    {
      "name": "Encik Tan",
      "location": "1.4026619, 103.9131342",
      "vicinity": " 681, #01-39 Punggol Dr, Oasis Terraces, Singapore    S(820681)",
      "information": null,
      "terms": null,
      "number": null,
      "site": null,
      "photos": null,
      "videos": null,
      "url": "node/13083"
    },
    {
      "name": "Encik Tan",
      "location": "1.391785, 103.895219",
      "vicinity": " Compass One, 1 Sengkang Square #02-29, Singapore    S(545078)",
      "information": null,
      "terms": null,
      "number": null,
      "site": null,
      "photos": null,
      "videos": null,
      "url": "node/13083"
    },
    {
      "name": "Encik Tan",
      "location": "1.33352, 103.740277",
      "vicinity": " Jcube, 2 Jurong East Central 1, #B1-K05, Singapore    S(609578)",
      "information": null,
      "terms": null,
      "number": null,
      "site": null,
      "photos": null,
      "videos": null,
      "url": "node/13083"
    },
    {
      "name": "Encik Tan",
      "location": "1.3186216, 103.8941335",
      "vicinity": " 10 Eunos Rd 8, #B1-156/159 SingPost Centre, Singapore    S(408600)",
      "information": null,
      "terms": null,
      "number": null,
      "site": null,
      "photos": null,
      "videos": null,
      "url": "node/13083"
    },
    {
      "name": "Encik Tan",
      "location": "1.35296, 103.940345",
      "vicinity": " 51 Tampines Ave 4, #01-12 Our Tampines Hub, Singapore    S(528523)",
      "information": null,
      "terms": null,
      "number": null,
      "site": null,
      "photos": null,
      "videos": null,
      "url": "node/13083"
    },
    {
      "name": "Encik Tan",
      "location": "1.406756, 103.902307",
      "vicinity": " 83 Punggol Central, B2-03, Waterway Point, Singapore    S(828761)",
      "information": null,
      "terms": null,
      "number": null,
      "site": null,
      "photos": null,
      "videos": null,
      "url": "node/13083"
    },
    {
      "name": "Encik Tan",
      "location": "1.39725, 103.746941",
      "vicinity": " 21 Choa Chu Kang North 6, #B1-28 Yew Tee Point, Singapore    S(689578)",
      "information": null,
      "terms": null,
      "number": null,
      "site": null,
      "photos": null,
      "videos": null,
      "url": "node/13083"
    },
    {
      "name": "Encik Tan",
      "location": "1.32481, 103.929359",
      "vicinity": " Bedok Mall, 311 New Upper Changi Road #B1-41/42, Singapore    S(467360)",
      "information": null,
      "terms": null,
      "number": null,
      "site": null,
      "photos": null,
      "videos": null,
      "url": "node/13083"
    },
    {
      "name": "Saffrons @ 1105",
      "location": "1.3521534, 103.9509891",
      "vicinity": " 201D Tampines Street 21, #01-1105, Singapore 524201 Tampines  S(524201)",
      "information": "&lt;p&gt;Saffrons Restaurant offers some of the best Indian Cuisine in Singapore, serving a tantalising collection of dishes that are suitable for family, large groups, catching up with friends and colleagues. From East to West, our extensive menu is reflective of our efforts to cater to every palate.&lt;/p&gt;\r\n\r\n&lt;p&gt;Saffrons Restaurant is also a&amp;nbsp;&lt;a href=&quot;https://www.sfa.gov.sg/food-retail/sfa-food-establishment-licenses/sfa-food-establishment-licenses&quot;&gt;Singapore Food Agency's Licensed&lt;/a&gt;&amp;nbsp;Caterer (100% Muslim Owned) . We are equipped to provide catering services for your corporate events, meetings, weddings and even to your home parties.&lt;/p&gt;\r\n",
      "terms": null,
      "number": "66354224",
      "site": null,
      "photos": [""],
      "videos": null,
      "url": "node/13083"
    },
    {
      "name": "Craze Kitchen",
      "location": "1.3522081, 103.9512546",
      "vicinity": " 201D Tampines Street 21, #01-1171, Singapore 524201 Tampines  S(524201)",
      "information": "&lt;p&gt;Multiple Award Winning Halal Certified Cafe&lt;/p&gt;\r\n\r\n&lt;p&gt;Speciality Pastas + Steaks + Burgers + Desserts&lt;/p&gt;\r\n",
      "terms": null,
      "number": "69700287",
      "site": null,
      "photos": [""],
      "videos": null,
      "url": "node/13083"
    },
    {
      "name": "Satay Shiok",
      "location": "1.2804659, 103.850303",
      "vicinity": "Stall No 1 Lau Pa Sat, 18 Raffles Quay   S(48582)",
      "information": "&lt;p&gt;Operation Hours : 7pm to 1am daily&lt;/p&gt;\r\n",
      "terms": null,
      "number": null,
      "site": null,
      "photos": null,
      "videos": null,
      "url": "node/10326"
    },
    {
      "name": "Liza Nasi Padang",
      "location": "1.3351961, 103.8560453",
      "vicinity": "#01-44 Blk 22, Lorong 7 Toa Payoh   S(310022)",
      "information": "&lt;p&gt;Operation Hours: 6am to&amp;nbsp;3pm. Closed every Saturday.&lt;/p&gt;\r\n",
      "terms": null,
      "number": null,
      "site": null,
      "photos": null,
      "videos": null,
      "url": "node/10326"
    },
    {
      "name": "Warong Pak Sapari",
      "location": "1.3249914, 103.8045992",
      "vicinity": "Stall No 2 Adam Road Food Centre, 2 Adam Rd   S(289877)",
      "information": "&lt;p&gt;Operation Hours: 8am to 4pm. Closed on every Monday &amp;amp; Tuesday.&lt;/p&gt;\r\n",
      "terms": null,
      "number": null,
      "site": null,
      "photos": null,
      "videos": null,
      "url": "node/10326"
    }
  ]
}
